export default __webpack_public_path__ + "static/media/loading-animation.63268d36.svg";